module.exports = __webpack_public_path__ + "static/img/AE.cb322be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/AE.svg
// module id = 2IhB
// module chunks = 66